'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { ChevronDown } from 'lucide-react';
import { useDataTable } from './context';
import styles from './DataTable.module.css';
export function ColumnFilter({ columnId, options, placeholder = 'All', 'aria-label': ariaLabel, }) {
    const { table } = useDataTable();
    const selectId = useId();
    const column = table.getColumn(columnId);
    if (!column)
        return null;
    const currentValue = column.getFilterValue() ?? '';
    // Derive options from column facets when not explicitly provided
    const resolvedOptions = options ??
        Array.from(column.getFacetedUniqueValues().keys())
            .sort()
            .map((v) => ({ value: String(v), label: String(v) }));
    const label = ariaLabel ?? `Filter by ${columnId}`;
    return (_jsxs("div", { className: styles.filterWrapper, children: [_jsx("label", { htmlFor: selectId, className: styles.srOnly, children: label }), _jsxs("select", { id: selectId, className: styles.filterSelect, value: currentValue, onChange: (e) => column.setFilterValue(e.target.value || undefined), "aria-label": label, children: [_jsx("option", { value: "", children: placeholder }), resolvedOptions.map(({ value, label: optLabel }) => (_jsx("option", { value: value, children: optLabel }, value)))] }), _jsx("span", { className: styles.filterChevron, "aria-hidden": "true", children: _jsx(ChevronDown, { size: 12 }) })] }));
}
//# sourceMappingURL=ColumnFilter.js.map